<template>
  <div>
    <strong>Process orders</strong>
    <br/><br/>
    <div @keydown.enter="process_orders_for_shop()">
      <label>Store: </label><StoreSelector v-validate="'required'" v-model="selected_store" />
      <br/><br/>
      <label class="label">Days: </label>
        <select v-model="number_of_days">
          <option v-for="n in max_days">{{n}}</option>
        </select>
      <br/><br/><a id='submit' @click="process_orders_for_shop()" class="button is-link" :disabled="buttonsDisabled"><span class="icon"><i class="fa fa-refresh"></i></span><span>Process Orders</span></a>
    </div>
  </div>
</template>

<script>
import auth from '../auth'
import StoreSelector from './StoreSelector'
import axios from 'axios'

export default {
  name: 'ProcessOrders',
  computed: {
    formValidated () {
      return this.selected_store && Object.keys(this.fields).every(key => this.fields[key].validated) && Object.keys(this.fields).every(key => this.fields[key].valid)
    },
    buttonsDisabled () {
      return !this.formValidated || this.force_buttons_disabled
    },
    processUrl () {
      return `${this.$constants.PROCESS_ORDERS}`
    }
  },
  data () {
    return {
      number_of_days: 1,
      selected_store: null,
      force_buttons_disabled: false,
      max_days: 5
    }
  },
  methods: {
    process_orders_for_shop () {
      if (this.force_buttons_disabled) {
        return
      }

      if (this.formValidated) {
        this.force_buttons_disabled = true
        axios.post(this.processUrl, {
          days: this.number_of_days,
          shop_url: this.selected_store
        })
          .then(response => {
            this.$root.open_message_modal('Processing orders with task ID: ' + response.data.task_id)
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            this.force_buttons_disabled = false
          })
      } else {
        this.$root.open_error_modal('Incomplete form!')
      }
    }
  },
  created () {
    auth.checkAuth(['trigger_backups'])
  },
  components: {
    StoreSelector
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
label { display: inline-block; width: 150px; text-align: left; font-weight: normal; }
</style>
